import React from 'react';
import { Route, Switch, Router } from 'react-router-dom';
import { ConnectedRouter } from 'connected-react-router';
import { ReactNotifications } from 'react-notifications-component';

import ErrorBoundary from './pages/ErrorBoundary';
import NotFound from './pages/404';
import Routers from './routers';

import { history } from './history';
import { allRoutes } from './routers/modules';

const App = () => {
  if (history.location?.pathname?.includes('admin')) {
    history.replace(history.location.pathname?.replace(/^(admin)|(\/admin)/gm, ''));
  }

  return (
    <ErrorBoundary>
      <ReactNotifications />
      <ConnectedRouter history={history}>
        <Router history={history}>
          <Switch>
            {allRoutes.map((route) => (
              <Route key="First" exact path={route.link} render={() => <Routers {...route} />} />
            ))}
            <Route path="*" component={NotFound} />
          </Switch>
        </Router>
      </ConnectedRouter>
    </ErrorBoundary>
  );
};

export default App;
